import { render, staticRenderFns } from "./lawPhase.vue?vue&type=template&id=fa742220&scoped=true&"
import script from "./lawPhase.vue?vue&type=script&lang=js&"
export * from "./lawPhase.vue?vue&type=script&lang=js&"
import style0 from "./lawPhase.vue?vue&type=style&index=0&id=fa742220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa742220",
  null
  
)

export default component.exports